import myLayout from "@/views/My/Layout/index.vue";

export default [
  {
    path: "",
    component: myLayout,
    children: [
      {
        path: "info",
        component: () => import("@/views/My/Info/index.vue"),
      },
      {
        path: "members",
        component: () => import("@/views/My/Members/index.vue"),
        props: (route) => ({ p: route.query.p }),
      },
      {
        path: "payments",
        component: () => import("@/views/My/Payments/index.vue"),
      },
    ],
  },
];
